import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import type { Role } from '../../types/permissions';

interface RoleGuardProps {
  /** Roles permitidos. Si el usuario tiene cualquiera de ellos, pasa. */
  roles: Role[];
  redirectTo?: string;
  children: ReactNode;
}

/**
 * Guardia por rol: renderiza children solo si el rol del usuario en la empresa
 * activa está entre los permitidos.
 *
 * Uso:
 *   <RoleGuard roles={['owner', 'admin']}><UsersManagementPage/></RoleGuard>
 */
const RoleGuard = ({ roles, redirectTo = '/acceso-denegado', children }: RoleGuardProps) => {
  const { hasRole, permissionsLoading } = usePermissions();

  if (permissionsLoading) return null;

  if (!hasRole(roles)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
